import React from "react";
import bootbox from "bootbox";

export default class PageActions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
    };

    this.onClick = this.onClick.bind(this);
    this.onShowActionModal = this.onShowActionModal.bind(this);
  }

  componentDidMount() {
    var self = this;
    $(document.body).on("click", function () {
      if (self.state.visible) {
        self.setState({ visible: false });
      }
    });
    this.setupExportChangeHandler();
  }

  setupExportChangeHandler() {
    $(document.body).on("change", "#export_format", function (e) {
      var $formatSelect = $("#export_format");

      // show/hide export options select boxes
      if ($formatSelect.val() == "pdf") {
        $("#export_content_ppt").attr("style", "display:none !important");
        $("#export_content_pdf").attr(
          "style",
          "display:inline-block !important"
        );
      } else if ($formatSelect.val() == "ppt") {
        $("#export_content_ppt").attr(
          "style",
          "display:inline-block !important"
        );
        $("#export_content_pdf").attr("style", "display:none !important");
      } else {
        // raw_file
        $("#export_content_ppt").attr("style", "display:none !important");
        $("#export_content_pdf").attr("style", "display:none !important");
      }
    });
  }

  /**
   * Render functions
   */

  render() {
    return (
      <div className="PageActions">
        <div className="dropdown">
          <button
            className="btn btn-default dropdown-toggle"
            type="button"
            onClick={this.onClick}
          >
            Actions
            <span className="caret"></span>
          </button>
          {this.renderActionDropdownMenu()}
        </div>
      </div>
    );
  }

  renderActionDropdownMenu() {
    return (
      <ul
        className="dropdown-menu"
        style={{ display: this.state.visible ? "block" : "none" }}
      >
        {this.props.course_collection && this.props.course_collection.id ? (
          <li>
            <a
              href="#"
              onClick={this.onShowActionModal.bind(this, "course_collection")}
            >
              <span className="fa fa-download"></span>{" "}
              {I18n.t("export_course_collection")}
            </a>
          </li>
        ) : null}
        {this.props.course &&
        this.props.course.id &&
        this.props.enable_course_exports ? (
          <li>
            <a href="#" onClick={this.onShowActionModal.bind(this, "course")}>
              <span className="fa fa-download"></span> {I18n.t("export_course")}
            </a>
          </li>
        ) : null}
        {this.props.article && this.props.article.id ? (
          <li>
            <a href="#" onClick={this.onShowActionModal.bind(this, "article")}>
              <span className="fa fa-download"></span>{" "}
              {I18n.t("export_article")}
            </a>
          </li>
        ) : null}
      </ul>
    );
  }

  renderExportModalContent(context, title, subtitle) {
    return `
			<div class="export-modal">
				<h2>${title}</h2>
				<h3>${subtitle}</h3>
				<div class="download-section">
					<div class="form-inline">
						<div class="form-group">
					    <label>Download As:</label>
					    <select id="export_format" class="form-control">
					    	${this.renderFormats().join("")}
					    </select>
					  </div>
						<div class="form-group">
							<div id="export_content_pdf">
						    <label>Include:</label>
						    <select class="form-control">
						    	<option value="full_content">Full Article Content</option>
						    	<option value="images_only">Images Only</option>
						    </select>
					    </div>
					    <div id="export_content_ppt" style="display:none !important">
					    	<label>Include:</label>
						    <select class="form-control">
						    	<option value="images_only">Images Only</option>
						    	<option value="images_with_notes">Images With Notes</option>
						    </select>
					    </div>
					  </div>
					</div>
				</div>
				<div class="loadingOverlay"><div class="spinner"></div></div>
			</div>
		`;
  }

  renderFormats() {
    var formats = [];

    if (this.props.formats.indexOf("PDF") >= 0) {
      formats.push('<option value="pdf">PDF</option>');
    }
    if (this.props.formats.indexOf("PPT") >= 0) {
      formats.push('<option value="ppt">PPT</option>');
    }
    if (this.props.raw_file_url) {
      var ext = this.getFileExtension(this.props.raw_file_url).toUpperCase();
      formats.push(`<option value="raw_file">${ext}</option>`);
    }

    return formats;
  }

  /**
   * Change handlers
   */

  onClick(e) {
    e.stopPropagation();
    e.preventDefault();
    this.setState({ visible: !this.state.visible });
  }

  onShowActionModal(context, e) {
    e.preventDefault();
    e.stopPropagation();

    if (context === "article") {
      this.onShowActionExportModal(
        context,
        this.props.article.name,
        `${I18n.t(context)}`,
        this.props.article.id
      );
    } else if (context === "course") {
      this.onShowActionExportModal(
        context,
        this.props.course.name,
        `${I18n.t(context)} - ${this.props.course.articles.length} ${I18n.t(
          "articles"
        )}`,
        this.props.course.id
      );
    } else if (context === "course_collection") {
      this.onShowActionExportModal(
        context,
        this.props.course_collection.name,
        `${I18n.t(
          context
        )} - ${this.getCourseCollectionArticleCount()} ${I18n.t("articles")}`,
        this.props.course_collection.id
      );
    }
  }

  onShowActionExportModal(context, title, subtitle, id) {
    var self = this;

    bootbox.dialog({
      className: "ExportModal",
      buttons: {
        cancel: {
          label: "Cancel",
          className: "btn-default btn-cancel",
        },
        download: {
          label: "Download",
          callback: function (download) {
            $(".export-modal .loadingOverlay").show();
            self.downloadFile(context, id);
            return false;
          },
        },
      },
      title: I18n.t(`export_${context}`),
      message: this.renderExportModalContent(context, title, subtitle),
    });
  }

  /**
   * Helper functions
   */

  downloadFile(context, id) {
    var self = this;
    var export_format = $("#export_format").val() || "raw_file";
    var export_content = self.getExportContent();

    var params = {
      course_id: self.props.course ? self.props.course.public_id : null,
      course_collection_id: self.props.course_collection
        ? self.props.course_collection.public_id
        : null,
      export_content: export_content,
      export_context: context,
      export_format: export_format,
      id: id,
      raw_file_url:
        export_format === "raw_file" ? self.props.raw_file_url : null,
    };

    var xhr = new XMLHttpRequest();
    xhr.open("POST", self.props.export_path, true);
    xhr.responseType = "arraybuffer";
    xhr.onload = function () {
      if (this.status === 200) {
        var filename = "";
        var disposition = xhr.getResponseHeader("Content-Disposition");
        if (disposition && disposition.indexOf("attachment") !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1])
            filename = matches[1].replace(/['"]/g, "");
        }
        var type = xhr.getResponseHeader("Content-Type");

        var blob;
        if (typeof File === "function") {
          try {
            blob = new File([this.response], filename, { type: type });
          } catch (e) {
            /* Edge */
          }
        }
        if (typeof blob === "undefined") {
          blob = new Blob([this.response], { type: type });
        }

        if (typeof window.navigator.msSaveBlob !== "undefined") {
          // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
          window.navigator.msSaveBlob(blob, filename);
        } else {
          var URL = window.URL || window.webkitURL;
          var downloadUrl = URL.createObjectURL(blob);
          if (filename) {
            // use HTML5 a[download] attribute to specify filename
            var a = document.createElement("a");
            // safari doesn't support this yet
            if (typeof a.download === "undefined") {
              window.location = downloadUrl;
            } else {
              a.href = downloadUrl;
              a.download = filename;
              document.body.appendChild(a);
              a.click();
            }
          } else {
            window.location = downloadUrl;
          }

          setTimeout(function () {
            URL.revokeObjectURL(downloadUrl);
          }, 100); // cleanup
        }
        $(".export-modal .loadingOverlay").hide();
        bootbox.hideAll();
      } else {
        $(".export-modal .loadingOverlay").hide();
        bootbox.hideAll();
        bootbox.alert(
          "We're sorry, but this could not be downloaded at this time. Please try again later."
        );
        $.ajax({
          type: "POST",
          url: "/email-error",
          data: {
            subject: "Error Downloading Content",
            body: `<p>A user attempted to download content on this page (${window.location.href}) and received an error that the content could not be downloaded at this time.</p>
			          			<p>Export params for debugging:
										   export_id: ${id}<br />
										   export_content: ${export_content}<br />
										   export_context: ${context}<br />
										   export_format: ${export_format}
			          			</p>
			          			`,
          },
        }).done(function (data) {
          // Shhh...
        });
      }
    };
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhr.send($.param(params));
  }

  getCourseCollectionArticleCount() {
    var article_count = 0;
    for (
      var i = 0, ilen = this.props.course_collection.courses.length;
      i < ilen;
      i++
    ) {
      article_count =
        article_count + this.props.course_collection.courses[i].articles.length;
    }
    return article_count;
  }

  getExportContent() {
    if ($("#export_content_pdf").is(":visible")) {
      return $("#export_content_pdf select").val();
    } else if ($("#export_content_ppt").is(":visible")) {
      return $("#export_content_ppt select").val();
    }
  }

  getFileExtension(str) {
    var r = /(?:\.([^.]+))?$/;
    var ext = r.exec(str)[1];
    return ext.split(/\#|\?/g)[0];
  }
}
